import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DemoState {
  isDemo: boolean
  currentStep: number
  totalSteps: number
  industry: string
  companyName: string
  mobileRequested: boolean
  mobilePhone: string
  mobileSmsSent: boolean
  adminEmail: string
  setDemo: (val: boolean) => void
  setIndustry: (industry: string, name: string) => void
  setMobile: (phone: string, sent: boolean) => void
  setAdminEmail: (email: string) => void
  nextStep: () => void
  prevStep: () => void
  setStep: (n: number) => void
  reset: () => void
}

export const useDemoStore = create<DemoState>()(
  persist(
    (set) => ({
      isDemo: false,
      currentStep: 0,
      totalSteps: 7,
      industry: 'field_services',
      companyName: '',
      mobileRequested: false,
      mobilePhone: '',
      mobileSmsSent: false,
      adminEmail: '',
      setDemo: (val) => set({ isDemo: val }),
      setIndustry: (industry, companyName) => set({ industry, companyName }),
      setMobile: (phone, sent) => set({ mobileRequested: true, mobilePhone: phone, mobileSmsSent: sent }),
      setAdminEmail: (email) => set({ adminEmail: email }),
      nextStep: () => set((s) => ({ currentStep: Math.min(s.currentStep + 1, s.totalSteps - 1) })),
      prevStep: () => set((s) => ({ currentStep: Math.max(s.currentStep - 1, 0) })),
      setStep: (n) => set({ currentStep: n }),
      reset: () => set({ isDemo: false, currentStep: 0, industry: 'field_services', companyName: '', mobileRequested: false, mobilePhone: '', mobileSmsSent: false, adminEmail: '' }),
    }),
    { name: 'hseq-demo' }
  )
)
